export const decisionReceiptLedgerVersion = "strategy-decision-ledger-0.1.0";
export const decisionReceiptLedgerStorageKey = "strategy.localDecisionReceiptLedger.v1";
export const decisionReceiptLedgerLimit = 20;

export const decisionReceiptLedgerCapability = {
  version: decisionReceiptLedgerVersion,
  storage: "browser_localStorage",
  limit: decisionReceiptLedgerLimit,
  productionClaim: false,
  serverCustodyClaim: false,
  claimBoundary:
    "Decision receipt ledger entries are local browser records only. They are not server custody, production deployment evidence, legal advice, financial advice, or formal verification."
};

export function buildDecisionLedgerEntry({ receipt, domain, selectedOption, createdAt = new Date().toISOString() }) {
  return {
    id: `decision-${createdAt}-${selectedOption?.id ?? "unknown"}`.replace(/[^a-zA-Z0-9_.:-]/g, "-"),
    schemaVersion: decisionReceiptLedgerVersion,
    createdAt,
    domainId: domain.id,
    domainLabel: domain.label,
    selectedOptionId: selectedOption?.id ?? null,
    selectedOptionLabel: selectedOption?.label ?? null,
    scorePercent: selectedOption?.scorePercent ?? null,
    blockedCount: receipt.blocked.length,
    needsEvidenceCount: receipt.needsEvidence.length,
    winnerId: receipt.winner?.id ?? null,
    productionClaim: false,
    formalVerificationClaim: false,
    claimBoundary:
      "Stored decision receipts are local operator-model audit records only. They are not advice, proof, production evidence, or server-side custody.",
    receipt
  };
}

export function validateDecisionLedgerEntry(entry) {
  return Boolean(
    entry &&
      entry.schemaVersion === decisionReceiptLedgerVersion &&
      entry.productionClaim === false &&
      entry.formalVerificationClaim === false &&
      typeof entry.claimBoundary === "string" &&
      entry.claimBoundary.includes("operator-model") &&
      entry.receipt?.claimBoundary?.includes("operator-model")
  );
}

export function summarizeDecisionLedger(entries = []) {
  return entries.reduce(
    (summary, entry) => {
      summary.total += 1;
      if (entry.productionClaim) summary.productionClaims += 1;
      if (entry.formalVerificationClaim) summary.formalVerificationClaims += 1;
      if (entry.needsEvidenceCount > 0) summary.needsEvidence += 1;
      if (entry.blockedCount > 0) summary.blocked += 1;
      return summary;
    },
    { total: 0, productionClaims: 0, formalVerificationClaims: 0, needsEvidence: 0, blocked: 0 }
  );
}

export function normalizeDecisionLedger(entries = []) {
  return entries.filter(validateDecisionLedgerEntry).slice(0, decisionReceiptLedgerLimit);
}

export function readDecisionLedger(storage = globalThis.localStorage) {
  if (!storage) return [];
  try {
    const parsed = JSON.parse(storage.getItem(decisionReceiptLedgerStorageKey) ?? "[]");
    return normalizeDecisionLedger(Array.isArray(parsed) ? parsed : []);
  } catch {
    return [];
  }
}

export function writeDecisionLedger(entries, storage = globalThis.localStorage) {
  const normalized = normalizeDecisionLedger(entries);
  if (!storage) return normalized;
  storage.setItem(decisionReceiptLedgerStorageKey, JSON.stringify(normalized));
  return normalized;
}

export function appendDecisionLedgerEntry(entry, currentEntries = []) {
  return normalizeDecisionLedger([entry, ...currentEntries]);
}
